// extracted by mini-css-extract-plugin
export default {"root":"LayoutHelloElton_root__myvLs","container":"LayoutHelloElton_container__6InCH"};